import { faArrowsRotate, faCopy, faFileSlash } from '@fortawesome/pro-light-svg-icons'
import PermissionChecker from '../../../../../../../../../baseComponents/PermissionChecker'
import { TwinIconToolTip } from '../../../../../../../../../baseComponents/TwinIcon'
import { OrderData } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import { getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import ModalSellInvoiceDuplicate from './ModalSellInvoiceDuplicate'
import ModalRecalculateSellInvoice from './ModalRecalculateSellInvoice'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import locations from '../../../../../../../../../utils/globals/locations'

interface SellInvoiceDuplicateButtonProps {
    allRowData: OrderData
    title: string
    id: string
    children?: React.ReactNode
}

export const SellInvoiceDuplicateButton: React.FC<SellInvoiceDuplicateButtonProps> = ({ allRowData, id, title, children }) => {
    const { openModal, setOpenModal } = useSellInvoiceDuplicateButtonLogic()
    return (
        <PermissionChecker permission='create' userPermissions={getUserPermissions('sell.invoice')}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faCopy} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalSellInvoiceDuplicate setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => { }} /> : null}
        </PermissionChecker>
    )
}

const useSellInvoiceDuplicateButtonLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    return { openModal, setOpenModal }
}

interface SellInvoiceRecalculateButtonProps {
    allRowData: OrderData
    onSubmit?: () => void
    title: string
    id: string
    children?: React.ReactNode
}

export const SellInvoiceRecalculateButton: React.FC<SellInvoiceRecalculateButtonProps> = ({ allRowData, onSubmit, id, title, children }) => {
    const { openModal, setOpenModal } = useSellInvoiceRecalculateButtonLogic()
    return (
        <PermissionChecker permission='update' userPermissions={getUserPermissions('sell.invoice')}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })} >
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faArrowsRotate} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalRecalculateSellInvoice setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => onSubmit?.()} /> : null}
        </PermissionChecker>
    )
}

const useSellInvoiceRecalculateButtonLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    return { openModal, setOpenModal }
}

interface SellInvoiceRefundCreateButtonProps extends SellInvoiceRefundCreateButtonLogicProps {
    id: string
    title: string
    className?: string
    children?: React.ReactNode
}

export const SellInvoiceRefundCreateButton: React.FC<SellInvoiceRefundCreateButtonProps> = ({ id, className, title, Order, children }) => {
    const { createSellInvoiceRefund } = useSellInvoiceRefundCreateButtonLogic({ Order })
    return (
        <PermissionChecker userPermissions={getUserPermissions('sell.refundInvoice')} permission={'create'}>
            <div className={'flex flex-col relative ' + (className || '')} onClick={createSellInvoiceRefund}>
                {children ?? <TwinIconToolTip id={'sellInvoiceRefund' + id} classNameIcon={'regular22 hover:text-green-43 ' + (className || '')} message={title} icon={faFileSlash} />}
            </div>
        </PermissionChecker>
    )
}

interface SellInvoiceRefundCreateButtonLogicProps {
    Order: TwinDictionary
}

const useSellInvoiceRefundCreateButtonLogic = ({ Order }: SellInvoiceRefundCreateButtonLogicProps) => {
    const navigate = useNavigate()
    const createSellInvoiceRefund = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/sell/sellInvoice/getSellInvoiceComplete', { id: Order?.id, includeRelations: true })
        if (result) {
            const myId = result?.header?.id
            if (myId) {
                navigate(locations.sellInvoiceRefundMulti + '/generateFromInvoice/' + myId)
            }
        }
    }, [Order?.id, navigate])
    return { createSellInvoiceRefund }
}